import React from "react";

const FEATURES = [
  {
    title: "Solusi Audiovisual yang Andal & Akurat",
    desc:
      "solusi dan perangkat audiovisual kami telah dilengkapi dengan hardware terbaik, mampu menampilkan konten secara sempurna baik pada satu layar maupun multi-display. Solusi ini telah digunakan di berbagai industri untuk menarik audiens secara efektif.",
  },
  {
    title: "Solusi Efektif untuk Berbagai Interaksi dan Komunikasi",
    desc:
      "Tingkatkan komunikasi Anda dengan berbagai produk Interactive Display dari kami yang dirancang untuk menyampaikan pesan lebih efektif. Gunakan sesuai kebutuhan, seperti peta interaktif, media presentasi, hingga papan tulis pintar untuk kebutuhan ruang rapat Anda.",
  },
  {
    title: "Integrasi Produk Audiovisual untuk Pengaturan yang Lebih Efisien",
    desc:
      "Anda dapat menggabungkan berbagai tipe display dan produk audiovisual dari kami ke dalam satu ruangan sehingga memungkinkan pengaturan yang lebih efisien dan terintegrasi.",
  },
  {
    title: "Kolaborasi Efektif dengan Teknologi Display",
    desc:
      "Tingkatkan produktivitas ruang kerja Anda dengan teknologi display canggih seperti Paperless Conferece System, hingga All in One LED Display yang dapat dengan mudah menghubungkan tim sehingga kolaborasi dapat menjadi lebih praktis dan efisien.",
  },
];

export default function WhyChoose() {
  return (
    <section className="relative mt-0 bg-[#2E7462] md:bg-transparent">
      <div className="hidden md:block absolute inset-0">
        <img
          src="/images/bg-whychoose.png"
          alt="Background Why Choose Us"
          className="w-full h-full object-cover"
          loading="lazy"
          decoding="async"
          onError={(e) => {
            const el = e.currentTarget;
            el.onerror = null;
            el.src = "/images/bg-whychoose-fb.png";
          }}
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/30 via-black/20 to-black/30" />
      </div>

      <div className="relative text-white">
        <div className="container mx-auto px-4 sm:px-6 lg:px-8 pt-10 md:pt-12 pb-6 md:pb-8">
          <div
            className="text-center"
            data-aos="fade-up"
            data-aos-duration="600"
          >
            <h2 className="font-semibold mb-3 text-[24px] md:text-[33px]">
              Mengapa Memilih Kami?
            </h2>
            <p className="mx-auto text-white/90 leading-7 max-w-[62ch] text-[15px] md:text-[16px]">
              Produk berkualitas, layanan istimewa, dan keahlian yang dapat
              diandalkan.
            </p>
          </div>
        </div>

        <div className="mx-auto max-w-6xl px-4 sm:px-6 lg:px-8 pb-10 md:pb-12">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6 md:gap-7">
            {FEATURES.map((f, i) => {
              const row = Math.floor(i / 2);
              const delay = row * 140;
              const isLeft = i % 2 === 0;
              const aosType = isLeft ? "fade-right" : "fade-left";

              return (
                <div
                  key={f.title}
                  className="group rounded-xl border border-white/15 bg-white/10 backdrop-blur-sm p-6 md:p-7
                    shadow-[0_8px_24px_-10px_rgba(0,0,0,0.35)] transition-all
                    hover:shadow-[0_16px_32px_-12px_rgba(0,0,0,0.45)] hover:bg-white/15"
                  data-aos={aosType}
                  data-aos-duration="800"
                  data-aos-delay={delay}
                  data-aos-offset="200"                   
                  data-aos-anchor-placement="top-bottom" 
                >
                  <h3 className="text-[18px] md:text-[20px] font-semibold mb-3">{f.title}</h3>
                  <p className="text-white/90 leading-7 text-[14px] md:text-[15px] line-clamp-5">
                    {f.desc}
                  </p>
                </div>
              );
            })}
          </div>

        </div>
      </div>
    </section>
  );
}
